export const MESSAGE_LOAD_ERROR_TEXT =
  'Sorry, we’re having issues and couldn’t load this message.\n We apologize for the inconvenience';

// Generic error page messages
export const ERROR_MESSAGE = 'Something went wrong';
export const ERROR_DETAILS = 'Please try again later.';

// 404 error page messages
export const NOT_FOUND_MESSAGE = 'Page not found';
export const NOT_FOUND_DETAILS = 'The page you’re looking for doesn’t exist.';
